import { render } from "./LoaderView.vue?vue&type=template&id=44be97da&scoped=true"
const script = {}

import "./LoaderView.vue?vue&type=style&index=0&id=44be97da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44be97da"]])

export default __exports__